module.exports = __webpack_public_path__ + "img/bg_spark.1ea3418c.png";